// extracted by mini-css-extract-plugin
export default {"main":"examInfo_main__9Dh7J","score":"examInfo_score__yYxow","title":"examInfo_title__llJwE","item":"examInfo_item__dcy-I"};